import { useEffect } from "react";
import { useAppDispatch } from "../../common/store";
import { sendMessageLogSubmission } from "../../common/store/chat/thunks/send-message-log";
import VurbalizeEvents from "../../common/types/dto/chat/vurbalize-events";
import getMessageByVurablizeEvent from "../utils/get-message-by-vurablize-event";

//For merchant : b6783969bc077c42bef036b471e89631d7e6ca9d4f1a6032b5ad2c0e982a7dec
export const useHubspotFormSubmission = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event?.data?.eventName === 'onFormSubmitted' && event?.data?.type === 'hsFormCallback') {
        dispatch(sendMessageLogSubmission({
          data: {
            message: getMessageByVurablizeEvent(VurbalizeEvents.HUBSPOT_FORM_SUBMITTED),
            event_name: VurbalizeEvents.HUBSPOT_FORM_SUBMITTED,
            event_data: {
              timestamp: Date.now(),
              currentUrl: window.location.href
            },
          }
        }))
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
};